import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { api } from "../services/api";

import {
    Address,
    Benefit,
    FieldsInduction,
    IFormInput, Induction,
    InductionConfiguration,
    InductionContextData,
    InductionQuizConfiguration,
    Prescriber, QuestionsResponse,
    QuizInduction,
    SendSMS,
    SendEmail,
    IShowLGPDModal,
    User,
    Store,
    BeneficiaryPreCadastro,
    InductionQuestionConfiguration
} from "../TypesOrInterfaces/induction";
import { formatDate } from "../util/format";
import attachments from "../acceptanceTerm.json";
import systemToken from "../systemToken.json";
import jwtDecode from "jwt-decode";
import { ISearchFormInput } from "../util/types/Search";
import AlertModal from "../components/AlertModal";
import { ModalValidTerm } from "../components/ModalValidTerm";
import { acceptanceTermEmailOnlyBenefitIds, caregiverApiAlias, contactAcceptanceBenefitIds, FAZ_BEM_ID, NESTLE_ID } from "../util/aliasHidden";
import { getBeneficiaryPreCadastro } from "../services/beneficiaryPreCadastro";
import { normalizeCnpj } from "../util/pattern";
import { acceptanceTermQuestionAliases, hasQuizQuestionsOutsideBeneficiaryForm } from "../util/quizForm";


interface InductionProviderProps {
    children: ReactNode;
}

interface ResponseBeneficiary {
    data: Induction;
    success: boolean;
    error?: {
        code: number,
        message: string
    }
    messages: [
        {
            index: number,
            message: string
        }
    ]
}

interface ResponseConfiguration {
    data: InductionConfiguration;
    success: boolean;
    error?: {
        code: number,
        message: string
    }
}

interface ResponseStore {
    data: Store;
    success: boolean;
    error?: {
        code: number
        message: string
    }
}

interface ResponseBenefits {
    data: Benefit[];
    success: boolean;
    error?: {
        code: number
        message: string
    }
}

interface ResponseAddress {
    data: Address;
    success: boolean;
    error?: {
        code: number,
        message: string
    }
}

interface ResponsePrescriber {
    data: Prescriber[];
    success: boolean;
    error?: {
        code: number,
        message: string
    }
}

interface ResponseBenefit {
    data: {
        id: number;
        name: string;
    };
    success: boolean;
    error?: {
        code: number,
        message: string
    }
}

interface Token {
    exp: number;
    iat: number;
}

const benefitsEmail: number[] = [79721, 43461, 91021, 134129, 120325, 142326, 263326, 286626, 297026];
const benefitsLGPD: number[] = [91021, 120325];

const InductionContext = createContext<InductionContextData>({} as InductionContextData);

export function InductionProvider({ children }: InductionProviderProps) {
    const [token, setToken] = useState<string>();
    const [configuration, setConfiguration] = useState<InductionConfiguration>({} as InductionConfiguration);

    const [beneficiaryRegister, setBeneficiaryRegister] = useState<Induction>({} as Induction);

    const [haveRegistration, setHaveRegistration] = useState(false);

    const [displayStore, setDisplayStore] = useState(true);
    const [displayBenefits, setDisplayBenefits] = useState(false);
    const [displaySearch, setDisplaySearch] = useState(false);
    const [displayForm, setDisplayForm] = useState(false);
    const [displayQuizzes, setDisplayQuizzes] = useState(false);
    const [displayValidTermAccepted, setDisplayValidTermAccepted] = useState(false);

    const [cardHolderNumber, setCardHolderNumber] = useState('');

    const [beneficiaryInfo, setBeneficiaryInfo] = useState<ISearchFormInput>();
    const [canProceedWithoutAccept, setCanProceedWithoutAccept] = useState<boolean>(false);

    // states para controlar quando o modal de inserido ou erro aparecerá
    // const [beneficiaryInserted, setBeneficiaryInserted] = useState<boolean>(false);
    const [beneficiaryInsertedError, setBeneficiaryInsertedError] = useState<boolean>(false);
    const [showModalResultInserted, setShowModalResultInserted] = useState<boolean>(false);

    const [address, setAddress] = useState<Address>({} as Address);
    const [prescriber, setPrescriber] = useState({} as Prescriber);
    const [store, setStore] = useState<Store>({} as Store);
    const [benefits, setBenefits] = useState<Benefit[]>([] as Benefit[]);

    const [fields, setFields] = useState<FieldsInduction[]>([]);
    const [quizzes, setQuizzes] = useState<QuizInduction[]>([]);
    const [addedQuiz, setAddedQuiz] = useState(false);
    const [benefitName, setBenefitName] = useState('');
    const [editContact, setEditContact] = useState(false);

    const [beneficiaryBirthDate, setBeneficiaryBirthDate] = useState('');
    const [questionResponsibleDocument, setQuestionResponsibleDocument] = useState('');
    const [questionResponsibleName, setQuestionResponsibleName] = useState('');
    const [questionResponsibleBirthDate, setQuestionResponsibleBirthDate] = useState('');
    const [questionResponsibleDegreeKinship, setQuestionResponsibleDegreeKinship] = useState('');
    const [questionResponsibleAcceptance, setQuestionResponsibleAcceptance] = useState(false);
    const [questionReceiveAccess, setQuestionReceiveAccess] = useState('');
    const [userLogin, setUserLogin] = useState<User>();
    const [isActiveLoader, setIsActiveLoader] = useState(false);
    const [optionSendAcceptanceTerm, setOptionSendAcceptanceTerm] = useState(1);
    const [otherIssuesBeyondTheTerm, setOtherIssuesBeyondTheTerm] = useState(false);
    const [contact0, setContact0] = useState(true);
    const [contact1, setContact1] = useState(true);
    const [contact2, setContact2] = useState(true);
    const [contact3, setContact3] = useState(true);

    const [isUpdate, setIsUpdate] = useState(false);

    const [fieldsCaregiver, setFieldsCaregiver] = useState<InductionQuestionConfiguration[]>([])
    const [caregiverData, setCaregiverData] = useState<any>()

    const [beneficiaryHasCaregiver, setBeneficiaryHasCaregiver] = useState<boolean>(false);
    const [plainHasCaregiver, setPlainHasCaregiver] = useState<boolean>(false);
    const [checkBoxesCaregiven, setCheckBoxesCaregiven] = useState<InductionQuestionConfiguration[]>([]);
    const [lastCaregivenData, setLastCaregivenData] = useState<any>();
    const [fieldsCaregiverData, setFieldsCaregiverData] = useState<any>({});

    const [showLGPDModal, setShowLGPDModal] = useState<IShowLGPDModal>({
        benefit: '',
        open: false
    });

    const [errorAddBeneficiaryPreCad, setErrorAddBeneficiaryPreCad] = useState(false);
    const [errorAddBeneficiaryPreCadMessage, setErrorAddBeneficiaryPreCadMessage] = useState('');

    const [termDeclined, setTermDeclined] = useState(false);

    const getUrlParameter = (name: string) => {
        const search = window.location.href.replace(/(.*)(?=\?)/, "");
        const params = new URLSearchParams(search);

        return params.get(name);
    }


    const [benefitId, setBenefitId] = useState(() => {
        const benefitIdParam = getUrlParameter('benefitId') || "";

        if (benefitIdParam) {

            if (isNaN(parseInt(benefitIdParam))) {

                return 0;
            }

            const numBenefitId = Number(benefitIdParam);

            setDisplaySearch(true);

            setDisplayStore(false);
            setDisplayBenefits(false);
            return numBenefitId;
        }

        //toast.error('Parametros não enviados!');
        return 0;
    });

    const [showHeaderFooter, setShowHeaderFooter] = useState(() => {
        const isShowing = (getUrlParameter('showHeaderFooter') ?? "true") == "true";
        return isShowing;
    });

    const [beneficiaryIdentifier, setBeneficiaryIdentifier] = useState(() => {
        return getUrlParameter('beneficiaryIdentifier') ?? "";
    });

    const [originOfAccessPosWeb, setOriginOfAccessPosWeb] = useState(() => {
        const isPOSWeb = (getUrlParameter('origin') ?? "") == "POSWEB";
        return isPOSWeb;
    });

    const [termAccepted, setTermAccepted] = useState(false);

    useEffect(() => {
        const authentication = async () => {

            const tokenLocal = localStorage.getItem('@EpharmaInductionToken');

            //incluir validações se o token é valido se não gera outro
            if (tokenLocal) {

                const decoded = jwtDecode<Token>(tokenLocal);

                if (new Date(decoded.exp * 1000) > new Date()) {
                    setToken(tokenLocal);
                    return;
                }

                await getAuthentication();
            }

            await getAuthentication();
        }

        authentication();

    }, []);

    async function getAuthentication() {
        setIsActiveLoader(true);

        await api.get('/Authentication/api/v1/OAuth/Authenticate'
            , {
                headers: {
                    'client_id': window.configInduction.authClientId,
                    'username': window.configInduction.authUsername,
                    'password': window.configInduction.authPassword
                }
            }
        ).then(response => {
            if (response.status !== 200) {
                toast.error('Erro na autenticação do portal, tente novamente mais tarde ou entre em contato na ePharma');
            }
            //toast.success('Autenticou com sucesso');

            localStorage.setItem('@EpharmaInductionToken', response.data.data.token.accessToken);

            setToken(response.data.data.token.accessToken);

        }).catch((error) => {
            toast.error('Ocorreu um erro na aplicação por favor tente mais tarde!')
        }).finally(() => {
            setIsActiveLoader(false);
        });

    }

    useEffect(() => {
        setIsActiveLoader(true);
        if (token) {
            Promise.all([

                api.get<ResponseConfiguration>(`/Client/api/v1/Benefit/Beneficiary/Register/Configuration/${benefitId}`
                    , {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                ),
                api.get<ResponseBenefit>(`/Client/api/v1/Benefit/${benefitId}`
                    , {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }

                )
            ]).then((values) => {
                const data = values[0].data.data
                hasCaregiver(data.quiz)
                setIsActiveLoader(true);
                setConfiguration(data);

                const otherQuestions = hasQuizQuestionsOutsideBeneficiaryForm(values[0].data.data, benefitId);

                //const questionAccepte = values[0].data.data.quiz.flatMap(quiz => quiz.questions).filter(question => question.questionAlias.toLocaleLowerCase() === 'question_accepted_term');
                const questionAccepteLate = values[0].data.data.quiz.flatMap(quiz => quiz.questions).filter(question => question.questionAlias.toLocaleLowerCase() === 'question_late-term_acceptance');

                // caso tenho o termo de aceite tardio o beneficiario pode aceitar o termo depois, deve liberar o usuario para seguir com o cadastro
                if (questionAccepteLate.length > 0 || benefitId === FAZ_BEM_ID || benefitId === NESTLE_ID) {
                    setCanProceedWithoutAccept(true);
                } else if (questionAccepteLate.length === 0) {
                    setCanProceedWithoutAccept(false);
                }

                setOtherIssuesBeyondTheTerm(otherQuestions);
                setBenefitName(values[1]?.data?.data.name);
            }).catch((error) => {
                console.error(`Error na consulta das configurações: ${error}`)
            }).finally(() => {
                setIsActiveLoader(false);
            });
        }
    }, [benefitId, token]);
    
    function hasCaregiver(medicamento: InductionQuizConfiguration[]) {

        const quizzes = medicamento.flatMap(x => x.questions).filter(x => {

            return caregiverApiAlias.includes(x.questionAlias.toLocaleLowerCase())

        }) as InductionQuestionConfiguration[]



        var caregiverQuestionAlias = new Set()

       
        const tempFieldsCaregiver = quizzes.filter((x: InductionQuestionConfiguration) => {
            const hasDup = caregiverQuestionAlias.has(x.questionAlias)
            caregiverQuestionAlias.add(x.questionAlias)
            return !hasDup

        }).sort((a, b) => {
            if (a.order > b.order)
                return 1;
            else if (a.order < b.order) return -1;
            return 0;
        })

        setFieldsCaregiver(tempFieldsCaregiver)
              

        return quizzes.length > 0

    }

    function resetBeneficiary() {
        setCardHolderNumber('');
        setAddress({} as Address);
        setPrescriber({} as Prescriber);
        setUserLogin({} as User);
        setFields([]);
        setQuizzes([]);
        setBeneficiaryRegister({} as Induction);
        setQuestionResponsibleDocument('');
        setQuestionResponsibleName('');
        setQuestionResponsibleBirthDate('');
        setQuestionResponsibleDegreeKinship('');
        setQuestionResponsibleAcceptance(false);
        setQuestionReceiveAccess('');
        setOptionSendAcceptanceTerm(0);
        localStorage.removeItem('@EpharmaInductionIsMinor');
        setOtherIssuesBeyondTheTerm(false);
        setIsActiveLoader(false);
        setBeneficiaryBirthDate('');
        setContact0(false);
        setContact1(false);
        setContact2(false);
        setContact3(false);
    }

    async function getBeneficiary(cardNumber: string) {
        setIsActiveLoader(true);

        try {
            const response = await api.get<ResponseBeneficiary>(`/Beneficiary/api/v1/Beneficiary/Dynamic/${benefitId}/${cardNumber}`
                , {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            setCardHolderNumber(cardNumber);

            if (!response.data.success && response.data.error?.code === 404) {
                setIsActiveLoader(false);
                return null;
            }

            let beneficiary = response.data.data;
            const questionAcceptContactTypeValues = configuration.quiz?.filter(
                quiz => quiz.questions?.filter(
                    question => question.questionAlias.toLowerCase() === 'question_accept_contact_types')
            ).length > 0;


            if (questionAcceptContactTypeValues) {
                configuration.quiz?.map(quiz => {
                    quiz.questions?.map(question => {
                        if (question.questionAlias.toLowerCase() === 'question_accept_contact_types') {
                            beneficiary?.quiz?.map(quizBenef => {
                                let item = quizBenef.questions.find(x => x.id == question.id);
                                if (item) {
                                    if (question.title.toLowerCase().includes("sms")) {
                                        setContact0(item.value == "true");
                                    }
                                    else if (question.title.toLowerCase().includes("corr")) {
                                        setContact1(item.value == "true");
                                    }
                                    else if (question.title.toLowerCase().includes("telefone")) {
                                        setContact2(item.value == "true");
                                    }
                                    else if (question.title.toLowerCase().includes("mail")) {
                                        setContact3(item.value == "true");
                                    }
                                }
                            });
                        }
                    })
                });
            }

            const birthdayId = Number(configuration.fields.filter(f => f.apiAlias === 'beneficiario_dt_nascimento')[0]?.columnId);
            
            if (birthdayId) {


                let birthday = beneficiary.fields.filter(f => f.columnId === birthdayId)[0].value?.split(' ')[0];
                const arrayDate = beneficiary.fields.filter(field => field.tableId === 1 && field.columnId === birthdayId)[0]?.value.split(/\s/)[0].split('/');
                // birthday = arrayDate[2] + '-' + arrayDate[0] + "-" + arrayDate[1];
                birthday = arrayDate[2] + '-' + arrayDate[1] + "-" + arrayDate[0];
                beneficiary.fields.filter(f => f.columnId === birthdayId)[0].value = birthday;
                setBeneficiaryBirthDate(birthday);

                if (birthday) {
                    const value = birthday.split('-').reverse().map(m => Number(m));

                    const result = Math.floor(
                        Math.ceil(Math.abs(
                            new Date(`${value[2]}-${value[1]}-${value[0] + 1}`).getTime() - new Date().getTime()
                        ) / (1000 * 3600 * 24)) / 365.25) < 18 ? true : false;

                    if (result) {

                        const responsibleDocument = beneficiary.quiz?.map(q => q.questions).flat().map(m => {
                            const iguals = configuration.quiz.map(c => {
                                return c.questions.filter(cf => cf.questionAlias.toLowerCase() === 'question_responsible_document')
                                    .map(question => question.id)
                            });

                            if (iguals.flat().includes(m.id) && m.value) {
                                return m.value
                            }

                            return ''
                        }).filter(f => f)[0];

                        const responsibleName = beneficiary.quiz?.map(q => q.questions).flat().map(m => {
                            const iguals = configuration.quiz.map(c => {
                                return c.questions.filter(cf => cf.questionAlias.toLowerCase() === 'question_responsible_name')
                                    .map(question => question.id)
                            });

                            if (iguals.flat().includes(m.id) && m.value) {
                                return m.value
                            }

                            return ''
                        }).filter(f => f)[0];

                        const responsibleBithDate = beneficiary.quiz?.map(q => q.questions).flat().map(m => {
                            const iguals = configuration.quiz.map(c => {
                                return c.questions.filter(cf => cf.questionAlias.toLowerCase() === 'question_responsible_birth_date')
                                    .map(question => question.id)
                            });

                            if (iguals.flat().includes(m.id) && m.value) {
                                return m.value
                            }

                            return ''
                        }).filter(f => f)[0];

                        const responsibleDegreeKinship = beneficiary.quiz?.map(q => q.questions).flat().map(m => {
                            const iguals = configuration.quiz.map(c => {
                                return c.questions.filter(cf => cf.questionAlias.toLowerCase() === 'question_responsible_degree_of_kinship')
                                    .map(question => question.id)
                            });

                            if (iguals.flat().includes(m.id) && m.value) {
                                return m.value
                            }

                            return ''
                        }).filter(f => f)[0];

                        const responsibleAcceptance = beneficiary.quiz?.map(q => q.questions).flat().map(m => {
                            const iguals = configuration.quiz.map(c => {
                                return c.questions.filter(cf => cf.questionAlias.toLowerCase() === 'question_responsible_acceptance')
                                    .map(question => question.id)
                            });

                            if (iguals.flat().includes(m.id) && m.value) {
                                return m.value
                            }

                            return ''
                        }).filter(f => f)[0];

                        setQuestionResponsibleDocument(responsibleDocument);
                        setQuestionResponsibleName(responsibleName);
                        setQuestionResponsibleBirthDate(responsibleBithDate);
                        setQuestionResponsibleDegreeKinship(responsibleDegreeKinship);
                        setQuestionResponsibleAcceptance(responsibleAcceptance == "true");
                    }
                }
            }

            setBeneficiaryRegister(beneficiary);
            setHaveRegistration(true);
            setDisplayForm(true);
            setDisplayValidTermAccepted(false);
            setDisplaySearch(false);
            setIsUpdate(true);

            if (!showHeaderFooter) {

                if (configuration.quiz?.length > 0 && otherIssuesBeyondTheTerm) {
                    setValueDisplayForm(false);
                    setValueDisplayQuizzes(true);
                }


                const beneficiaryChangedDate = configuration.fields.filter(field =>
                    field.apiAlias?.toLowerCase() === 'beneficiario_data_alteracao')[0];
                const existsChangeDate = configuration.fields.filter(field =>
                    field.apiAlias?.toLowerCase() === 'beneficiario_data_alteracao')[0] ? true : false;

                if (beneficiaryChangedDate && existsChangeDate)
                    beneficiary.fields.map(field => {
                        if (field.columnId == beneficiaryChangedDate.columnId) {
                            field.value = formatDate(new Date());
                        }
                        return field
                    })

                fields.length == 0 && setFields([...beneficiary.fields]);

            }
            setIsActiveLoader(false);

            return beneficiary;
        } catch {
            setIsActiveLoader(false);
            toast.error('Ocorreu um erro na aplicação por favor tente mais tarde!');
        }
    }

    async function saveInformationNewTableToSendTerm(data: ISearchFormInput) {
        try {
            data.cpf = data.cpf.replaceAll(/\D/g, "");
            data.celular = data.celular.replaceAll(/\D/g, "");
            data.tipoEnvio = normalizeDeliveryChannel(data.tipoEnvio);

            const beneficiarioExistente = await getBeneficiary(data.cpf);

            const quizId = getAcceptanceQuizId();
            data.quizId = quizId;

            // salva na nova tabela e envia o termo pelo oq o usuario escolheu
            setBeneficiaryInfo(data);
            setCardHolderNumber(data.cpf);

            const requestObject = {
                Id: 0,
                IsPln: benefitId,
                CPF: data.cpf,
                Telefone: data.celular,
                Email: data.email,
                TipoEnvio: getDeliveryChannelCode(data.tipoEnvio),
                CodigoQuiz: data.quizId,
                IsAceite: false
            };

            const response = await api.post("/Beneficiary/api/v1/BeneficiaryPreCadastro", requestObject, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data?.error) {
                if (response.data?.messages[0]?.message == "Beneficiário já existe" && benefitId === FAZ_BEM_ID) {
                    console.log("Pre cadastro encontrado!")
                } else {
                    const message = response.data?.messages[0]?.message ? response.data.messages[0].message : 'Ocorreu um erro ao inserir o beneficiário';

                    setErrorAddBeneficiaryPreCad(true);
                    setErrorAddBeneficiaryPreCadMessage(message);
                    return;
                }
            }

            if (beneficiarioExistente && !response.data.data?.isAceite) {
                setDisplayForm(false);
            }

            if (response.data.data.isAceite) {
                setDisplaySearch(false);
                setDisplayValidTermAccepted(false);
                setDisplayForm(true);

                return;
            }
    
            if (!response.data.data.isAceite && data.tipoEnvio === 'email') {
                // envia por email o termo
                await sendEmail(data.email, data.email, benefitName, benefitId, quizId, data.cpf);
            } else if (!response.data.data.isAceite && data.tipoEnvio === 'sms') {
                // envia via sms
                await sendSms(data.celular, quizId, data.email, data.cpf);
            }

            setDisplaySearch(false);
            setDisplayValidTermAccepted(true);
        } catch {
            setErrorAddBeneficiaryPreCad(true);
        }
    }

    function ProceedToForm(termAccepted: boolean) {
        if (termAccepted) {
            setDisplaySearch(false);
            setDisplayValidTermAccepted(false);
            setDisplayForm(true);
        }
    }

    function GoToForm() {
        setDisplaySearch(false);
        setDisplayValidTermAccepted(false);
        setDisplayForm(true);
    }

    function CheckQuizzesResponse(isUpdate: boolean, fields: FieldsInduction[], termAcceptedAtual: boolean = termAccepted) {

        let resultQuiz = quizzes;

        const hasQuiz = configuration.quiz.length > 0;

        // Quando o termo ja foi aceito (valor autoritativo vindo do pre-cadastro), reativamos a geracao
        // da resposta do termo mesmo em updates sem campos de quiz no formulario (ex.: Facilita Diabetes,
        // cujo unico item de quiz e o aceite do regulamento e nao e renderizado no FormDynamic).
        if (hasQuiz && benefitId !== 43461 && !otherIssuesBeyondTheTerm && (!isUpdate || termAcceptedAtual || fields.some(field => field.tableId === -1))) {

            const quizzesConfig = configuration.quiz?.filter(
                quiz => quiz.questions?.filter(
                    question => question.questionAlias.toLowerCase() === 'question_accepted_term'
                        || question.questionAlias.toLowerCase() === 'question_late-term_acceptance')
            );

            const TermQuizzesConfig = configuration.quiz.filter(e => e.questions.filter(e => acceptanceTermQuestionAliases.includes(e.questionAlias.toLowerCase())).length > 0)

            const unansweredQuizzes = TermQuizzesConfig.filter(x => {
                return !resultQuiz.find(e => e.id == x.id && e.configurationId == x.configurationId)?.id
            })

            const result = unansweredQuizzes.map(quiz => {
                return {
                    id: quiz.id,
                    configurationId: quiz.configurationId,
                    skuId: quiz.drugs?.map(sku => sku.skuId),
                    questions: quiz.questions.map(question => {
                        const field = fields.find(x => x.columnId == question.id);
                        const isAcceptanceQuestion = acceptanceTermQuestionAliases.includes(question.questionAlias.toLowerCase());

                        return {
                            id: question.id
                            // Aceite do termo deriva do valor autoritativo (isAceite do pre-cadastro), e nao
                            // do estado `termAccepted`, que pode estar defasado (setState assincrono) no momento do submit.
                            , value: isAcceptanceQuestion
                                ? `${!!(field?.value || termAcceptedAtual)}`
                                : field?.value || ''
                        } as QuestionsResponse
                    }).filter(f => f.id)

                } as QuizInduction
            }).filter(f => f.id);

            // resultQuiz = quizzes.length > 0 ? quizzes : result;
            resultQuiz = [...quizzes, ...result]
        }

        const idResponsibleBirthDate = configuration?.quiz?.map(quiz => {
            return quiz.questions.find(x => x.questionAlias.toLowerCase() == "question_responsible_birth_date")?.id
        }).filter(x => x);

        const idResponsibleDocument = configuration?.quiz?.map(quiz => {
            return quiz.questions.find(x => x.questionAlias.toLowerCase() == "question_responsible_document")?.id
        }).filter(x => x);

        resultQuiz.map(quiz => {


            quiz.questions = quiz.questions.filter(x => !!x).filter(x => x.value !== undefined)


            quiz.questions.map(question => {

                fields.filter(x => x.tableId == -1).map(fieldQuiz => {
                    if (fieldQuiz.columnId == question.id) {
                        question.value = question.value || fieldQuiz.value;
                        if (question.value != fieldQuiz.value) {
                            console.log(question.value, fieldQuiz.value)
                        }
                        //Formatando data para enviar 
                        if (idResponsibleBirthDate.includes(question.id)) {
                            const arrayDate = fieldQuiz.value.split('-');
                            question.value = `${arrayDate[2]}/${arrayDate[1]}/${arrayDate[0]}`;
                        }

                        if (idResponsibleDocument.includes(question.id)) {
                            question.value = fieldQuiz.value.replaceAll(/\D/g, "");
                        }
                    }
                });
            });
        });

        return resultQuiz
    }

    function verifyFieldsAfterSave(fields: FieldsInduction[]) {

        const configBirthDay = configuration.fields.filter(field =>
            field.apiAlias?.toLowerCase() === 'beneficiario_dt_nascimento')[0];

        if (configBirthDay) {
            let obj = fields.filter(f => f.columnId !== configBirthDay.columnId);

            const dataOriginal = fields.filter(f => f.columnId === configBirthDay.columnId)[0].value;


            const arrayDate = dataOriginal.split(/\s/)[0].split('-');

            var dataFormatted = new Intl.DateTimeFormat('fr-ca')
                .format(new Date(Number(arrayDate[0]), Number(arrayDate[1]) - 1, Number(arrayDate[2]))).split('-').reverse().join('/');

            obj.push({
                tableId: configBirthDay.tableId,
                columnId: configBirthDay.columnId,
                value: dataFormatted
            });

            return obj;
        }

        return fields;
    }

    async function setBeneficiary(fieldsOpcional: FieldsInduction[], optSendAccTerm: number = optionSendAcceptanceTerm) {
        try {
            setIsActiveLoader(true);

            const beneficiaryPreCadastro = await getBeneficiaryPreCad();

            setIsActiveLoader(true);

            const objFields = verifyFieldsAfterSave(fieldsOpcional.length > 0 ? fieldsOpcional : fields);

            const aceiteContatoField = configuration.fields.find(
                f => f.apiAlias?.toLowerCase() === 'beneficiario_aceite_contato'
            );

            // No fluxo Balcão o aceite pode ocorrer via checkbox no formulário sem pré-cadastro.
            // Deriva o aceite das respostas de quiz submetidas no form como fallback.
            const acceptanceTermQuestion = aceiteContatoField
                ? configuration.quiz.flatMap(q => q.questions)
                    .find(q => acceptanceTermQuestionAliases.includes(q.questionAlias.toLowerCase()))
                : undefined;
            const termAcceptedFromForm = acceptanceTermQuestion
                ? objFields.find(f => f.tableId === -1 && f.columnId === acceptanceTermQuestion.id)?.value === 'true'
                : false;

            if (!beneficiaryPreCadastro && !termAcceptedFromForm) {
                setIsActiveLoader(false);
                return;
            }

            // Valor autoritativo: pré-cadastro tem precedência; fallback para aceite via formulário (Balcão)
            const isAceiteAtual = (beneficiaryPreCadastro?.isAceite === true) || termAcceptedFromForm;

            let bodyFields = objFields.filter(x => x.tableId > 0);

            if (aceiteContatoField && contactAcceptanceBenefitIds.includes(benefitId)) {
                bodyFields = bodyFields.filter(f => f.columnId !== aceiteContatoField.columnId);
                bodyFields.push({
                    tableId: aceiteContatoField.tableId,
                    columnId: aceiteContatoField.columnId,
                    value: isAceiteAtual ? '7' : '0'
                });
            }

            let body: Induction = {
                fields: bodyFields,
                quiz: CheckQuizzesResponse(isUpdate, objFields, isAceiteAtual),
                hasCaregiver: beneficiaryHasCaregiver,
            };

            if (benefitId === FAZ_BEM_ID ) {
                body = {
                    ...body, extraFields: [
                        {
                            "key": "systemToken",
                            "value": window.configInduction.systemToken
                        },
                        {
                            "key": "permissionType",
                            "value": window.configInduction.permissionType
                        }
                    ]
                }

                if(!isUpdate){
                    body.extraFields?.unshift({
                        "key": "userPassword",
                        "value": beneficiaryInfo?.cpf
                    })
                }

            }
    

            let storeId = sessionStorage.getItem('storeId');

            if (!storeId) {
                const storeIdParam = getUrlParameter('storeId') || "";

                if (storeIdParam) {
                    storeId = isNaN(parseInt(storeIdParam)) ? '0' : storeIdParam;
                } else {
                    storeId = '0';
                }

            }

            const response = await api.post<ResponseBeneficiary>(`/Beneficiary/api/v1/Beneficiary/Dynamic/${benefitId}?originRegister=6&storeId=${storeId}`
                , body
                , {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            
            if (response.status !== 200) {
                setBeneficiaryInsertedError(true);
                setShowModalResultInserted(true);

                return;
            }

            if (!haveRegistration) {
                const exist = Object.keys(systemToken).find(key => key === benefitId.toString())?.length;

                if (exist) {
                    const sendPassword = questionReceiveAccess === '1' ? 'sendEmail=false&sendSms=true'
                        : 'sendEmail=true&sendSms=false';

                    const { data } = await api.post(`Authentication/api/v2/OAuth/?${sendPassword}`
                        , userLogin
                        , {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        });
                }

            }


            if (response.data.error) {
                setBeneficiaryInsertedError(true);
                setShowModalResultInserted(true);
                return;
            }

            setBeneficiaryInsertedError(false);
            setShowModalResultInserted(true);
            resetAll();
        }
        catch (error) {
            setBeneficiaryInsertedError(true);
            setShowModalResultInserted(true);
            return;
        }
        finally {
            setIsActiveLoader(false);
        }
    }

    async function validateRepresentativeCode(code: string): Promise<{ valid: boolean; error: string }> {
        if (!code || code.length !== 5) {
            return { valid: false, error: '' };
        }

        try {
            const response = await api.get(
                `/IndustryCMS/api/v1/RepresentativeCode/Validate`,
                {
                    params: { codigoPBM: code },
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (response.data?.success) {
                return { valid: true, error: '' };
            }

            const errorMsg =
                response.data?.messages?.[0]?.message ||
                response.data?.error?.message ||
                'Código de representante inválido';
            return { valid: false, error: errorMsg };
        } catch {
            return { valid: false, error: 'Erro ao validar código de representante' };
        }
    }

    async function resetPrescriber() {
        setPrescriber({} as Prescriber);
    }

    async function getPrescriber(state: string, prescriberCRM: string) {
        setIsActiveLoader(true);
        setPrescriber({} as Prescriber);
        const gridParams = `gridParams={"Page":0,"ItemsPerPage":0,
                            "Filter":[
                                {"property":"clientSystemNumber","operator":"=","value":"${prescriberCRM}"}
                                ,{"property":"clientSystemSg","operator":"=","value":"${state}"}
                                ,{"property":"prescriberTypeId","operator":"=","value":"1"}
                                ],"Sorter":[]}`

        const response = await api.get<ResponsePrescriber>(`/common/api/v1/Prescriber/Read?${gridParams}`
            , {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then(response => {
                if (response.status !== 200) {
                    toast.error('Erro na consulta do CRM');
                    return;
                }

                if (!response.data.success && response.data.error?.code === 404) {
                    toast.error('Por favor verifique o crm ou o estado do médico.');
                    return;
                }

                setPrescriber(response.data.data[0]);
            }).catch((error) => {
                toast.error('Ocorreu um erro na aplicação por favor tente mais tarde!')
            }).finally(() => {
                setIsActiveLoader(false);
            });

    }

    async function getAddressZipCode(zipCode: string) {
        setIsActiveLoader(true);
        const result = await api.get<ResponseAddress>(`Common/api/v1/Address/${zipCode}`
            , {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        ).then(response => {
            if (response.status !== 200) {
                toast.error('Erro na consulta de cep!');
                return {} as Address;
            }

            if (!response.data.success && response.data?.error?.code === 404) {
                toast.error('Consulta do cep não retornou nenhum endereço, por favor valide a numeração do cep!');

                return {} as Address;
            }

            return response.data.data;
        }).catch((error) => {
            toast.error('Ocorreu um erro na aplicação por favor tente mais tarde!');
            return {} as Address;
        }).finally(() => {
            setIsActiveLoader(false);
        });

        setAddress(result);

        return result;

    }

    function generateLink(quizId: number, cpf: string) {
        return `${window.configInduction.linkInduction}/${benefitId}/${cpf}/${quizId}`;
    }

    async function sendSms(numberPhone: string, quizId: number, beneficiaryName: string, cpf: string) {
        setIsActiveLoader(true);

        const message = window.configInduction.messageSMS.replace('[AcceptanceTermLink]', generateLink(quizId, cpf));

        const body: SendSMS = {
            system: 'ePharma.Induction',
            module: 'AcceptanceTerm',
            key: window.configInduction.smsKey,
            username: window.configInduction.smsUsername,
            password: window.configInduction.smsPassword,
            message: {
                recipient: {
                    mobile: numberPhone,
                    text: message
                }
            }

        }
        await api.post('/Messaging/api/v1/Sms', body, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            if (response.status !== 200) {
                toast.error('Erro ao enviar os termos de aceite via sms!');
                return;
            }
        }).catch((error) => {
            toast.error('Ocorreu um erro na aplicação ao enviar os termos de aceite')
        }).finally(() => {
            setIsActiveLoader(false);
        });
    }

    async function sendEmail(email: string, beneficiaryName: string, benefit: string, benefitId: number, quizId: number, cpf: string) {

        setIsActiveLoader(true);

        let attachment = { name: '', content: '' };

        if (benefitsEmail.includes(benefitId)) {

            attachment = (attachments as any)[benefitId];
        }

        const body: SendEmail = {
            system: 'ePharma.Induction',
            module: 'AcceptanceTerm',
            mail: {
                templateId: window.configInduction.templateEmailId,
                templateData: {
                    // 'patient_name': beneficiaryName,
                    'benefitName': benefit,
                    'arquivelink': generateLink(quizId, cpf),
                    'siteLink': benefitId === 79721 ?
                        'https://programaminhadii.com.br/' :
                        benefitId === 91021 ?
                            'https://uniaocomvoce.com.br/' :
                            benefitId === 43461 ?
                                'https://www.programanovodia.com.br/'
                                : benefitId === 142326 ? 'https://www.cristaliasaude.com.br/'
                                    : benefitId === 263326 ? 'https://meudescontonutricao.epharma.com.br/'
                                        : benefitId === 286626 ? 'https://programaviveradium.epharma.com.br/'
                                            : ''
                },
                from: {
                    name: 'ePharma',
                    email: 'enviodev@epharmatecnologia.com.br'
                },
                to: [
                    {
                        name: beneficiaryName,
                        email: email
                    }
                ],
                attachments: [
                    attachment
                ]
            }
        }

        await api.post('/Messaging/api/v1/Email', body, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            if (response.status !== 200) {
                toast.error('Erro ao enviar os termos de aceite via e-mail!');
                return;
            }
        }).catch((error) => {
            toast.error('Ocorreu um erro na aplicação ao enviar os termos de aceite')
        }).finally(() => {
            setIsActiveLoader(false);
        });
    }

    function closeModalDeclinedTerm() {
        setTermDeclined(false);

        setBeneficiaryInfo({} as ISearchFormInput);
        setCardHolderNumber('');

        setDisplaySearch(true);
        setDisplayValidTermAccepted(false);
        setDisplayForm(false);
        setDisplayQuizzes(false);
    }

    function resetAll() {
        setIsActiveLoader(true);

        setDisplayStore(true);
        setDisplayBenefits(false);
        setHaveRegistration(false);
        setDisplaySearch(false);
        setDisplayForm(false);
        setDisplayQuizzes(false);
        setCardHolderNumber('');
        setAddress({} as Address);
        setStore({} as Store);
        setBenefits([] as Benefit[]);
        setPrescriber({} as Prescriber);
        setUserLogin({} as User);
        setFields([]);
        setQuizzes([]);
        setBeneficiaryRegister({} as Induction);
        setBeneficiaryBirthDate('');
        setQuestionResponsibleDocument('');
        setQuestionResponsibleName('');
        setQuestionResponsibleBirthDate('');
        setQuestionResponsibleDegreeKinship('');
        setQuestionResponsibleAcceptance(false);
        setQuestionReceiveAccess('');
        setOptionSendAcceptanceTerm(0);
        // setSendAcceptanceTerm(true);
        // setuserRegistration(false);
        localStorage.removeItem('@EpharmaInductionIsMinor');
        setOtherIssuesBeyondTheTerm(false);
        setIsActiveLoader(false);
        setContact0(true);
        setContact1(true);
        setContact2(true);
        setContact3(true);
        setBeneficiaryInfo({} as ISearchFormInput);
    }

    function resetQuizzes() {
        setPrescriber({} as Prescriber);
    }

    async function addFields(data: IFormInput) {
        setIsActiveLoader(true);
        const normalizedCardHolderNumber = (cardHolderNumber || data['28'] || '').replace(/\D/g, '');
        /*hack para adicionar o cpf novamente no campo*/
        data['28'] = normalizedCardHolderNumber;
        // trativa campos de telefone
        if (data['19'])
            data['19'] = data['19'].replace(/\D/g, '');

        if (data['21'])
            data['21'] = data['21'].replace(/\D/g, '');

        //campo de cep
        if (data['18'])
            data['18'] = data['18'].replace(/\D/g, '');

        // adicionar os valores de cartao titular e cartao usuario e data inicio
        data['6'] = normalizedCardHolderNumber;
        data['7'] = normalizedCardHolderNumber;
        data['4'] = formatDate(new Date());

        if (normalizedCardHolderNumber && normalizedCardHolderNumber !== cardHolderNumber) {
            setCardHolderNumber(normalizedCardHolderNumber);
        }

        //Tratativa para pegar os dados dos responsaveis para ser usado na add do quiz
        if (data["question_responsible_document"]) {
            setQuestionResponsibleDocument(data["question_responsible_document"].replaceAll(/\D/g, ""));
        }

        if (data["question_responsible_name"]) {
            setQuestionResponsibleName(data["question_responsible_name"]);
        }

        if (data["question_responsible_birth_date"]) {
            setQuestionResponsibleBirthDate(data["question_responsible_birth_date"]);
        }

        if (data["question_responsible_degree_of_kinship"]) {
            setQuestionResponsibleDegreeKinship(data["question_responsible_degree_of_kinship"]);
        }

        if (data["question_responsible_acceptance"]) {
            setQuestionResponsibleAcceptance(data["question_responsible_acceptance"] == "true");
        }

        if (data["questionReceiveAccess"]) {
            setQuestionReceiveAccess(data["questionReceiveAccess"]);
        }

        // trativa campos de telefone e endereço
        const beneficiaryAddressLine = configuration.fields.filter(field => field.apiAlias?.toLowerCase() === 'beneficiario_endereco')[0];
        const beneficiaryNeighborhood = configuration.fields.filter(field => field.apiAlias?.toLowerCase() === 'beneficiario_endereco_bairro')[0];
        const beneficiaryState = configuration.fields.filter(field => field.apiAlias?.toLowerCase() === 'beneficiario_endereco_uf')[0];
        const beneficiaryCity = configuration.fields.filter(field => field.apiAlias?.toLowerCase() === 'beneficiario_endereco_cidade')[0];

        if (haveRegistration) {

            const existsChangeDate = configuration.fields.filter(field =>
                field.apiAlias?.toLowerCase() === 'beneficiario_data_alteracao')[0] ? true : false;

            const existAdrress = configuration.fields.filter(field =>
                field.apiAlias?.toLowerCase() === 'beneficiario_endereco_cidade')[0] ? true : false;

            const beneficiaryChangedDate = configuration.fields.filter(field => field.apiAlias?.toLowerCase() === 'beneficiario_data_alteracao')[0];
            if (beneficiaryChangedDate && existsChangeDate)
                data[beneficiaryChangedDate.columnId.toString()] = formatDate(new Date());

            if (beneficiaryCity && existAdrress)
                data[beneficiaryCity.columnId.toString()] = address?.city?.name ? address?.city?.name : beneficiaryRegister.fields.filter(f => f.columnId === beneficiaryCity.columnId)[0].value;

            if (beneficiaryAddressLine) {
                if (!data[beneficiaryAddressLine.columnId.toString()] && existAdrress) {
                    data[beneficiaryAddressLine.columnId.toString()] = beneficiaryRegister.fields.filter(f => f.columnId === beneficiaryAddressLine.columnId)[0].value;
                }
            }

            if (beneficiaryNeighborhood) {
                if (!data[beneficiaryAddressLine.columnId.toString()] && existAdrress) {
                    data[beneficiaryNeighborhood.columnId.toString()] = beneficiaryRegister.fields.filter(f => f.columnId === beneficiaryNeighborhood.columnId)[0].value;
                }
            }

        } else {
            if (!data[beneficiaryAddressLine?.columnId.toString()] && beneficiaryAddressLine)
                data[beneficiaryAddressLine.columnId.toString()] = address?.addressLine;

            if (!data[beneficiaryAddressLine?.columnId.toString()] && beneficiaryNeighborhood)
                data[beneficiaryNeighborhood.columnId.toString()] = address?.neighborhood;

            if (beneficiaryCity)
                data[beneficiaryCity?.columnId.toString()] = address?.city?.name;

            if (beneficiaryState)
                data[beneficiaryState?.columnId.toString()] = address?.city?.state?.stateCode;

            const gender = data['10'] === 'M' ? '0' : data['10'] === 'F' ? '1' :
                data['10'] === 'X' ? '2' : '3';

            const exist = Object.keys(systemToken).find(key => key === benefitId.toString())?.length;
            const text: any = systemToken;
            const token = !!exist ? text[benefitId] : '';
            const birthdate = data['9'] ? new Intl.DateTimeFormat('fr-ca').format(new Date(data['9']!)) : "";

            if (exist) {
                const userLogin: User = {
                    id: 0,
                    login: cardHolderNumber,
                    CPF: cardHolderNumber,
                    name: data['3']!,
                    mobilePhoneNumber: data['21']!,
                    socialName: '',
                    requireNewPassword: false,
                    birthDate: birthdate,
                    addressCity: address?.city?.name,
                    addressState: address?.city?.state?.stateCode,
                    addressLine: address?.addressLine,
                    addressNeighborhood: address?.neighborhood,
                    addressZipCode: data['18']?.replace(/\D/g, '')!,
                    startDate: new Intl.DateTimeFormat('fr-ca').format(new Date()),
                    email: data['50']!,
                    gender: gender,
                    systems: [
                        {
                            id: 0,
                            system: {
                                token: token
                            }
                        }
                    ]
                }

                setUserLogin(userLogin);
            }
        }

        let fields = configuration.fields.map(field => {
            if (data.hasOwnProperty(field.columnId)) {
                return {
                    tableId: field.tableId,
                    columnId: field.columnId,
                    value: data[field.columnId]
                } as FieldsInduction;
            }
            else if (!data.hasOwnProperty(field.columnId) && haveRegistration) {
                const fieldsBeneficiary = beneficiaryRegister.fields?.filter(f => f.columnId === field.columnId)[0];

                if (fieldsBeneficiary) {
                    return {
                        tableId: fieldsBeneficiary.tableId,
                        columnId: fieldsBeneficiary.columnId,
                        value: fieldsBeneficiary.value
                    } as FieldsInduction;
                }
            }
            return {} as FieldsInduction;

        }).filter(f => f.tableId);

        let quizInFields: FieldsInduction[] = [];
        configuration.quiz.map(quiz => {
            quiz.questions?.map(question => {
                if (data.hasOwnProperty(question.id) || data.hasOwnProperty(question.questionAlias.toLowerCase())) {
                    quizInFields.push({
                        tableId: -1,
                        columnId: question.id,
                        value: data[question.id] || data[question.questionAlias.toLowerCase()],
                        columnName: question.title
                    } as FieldsInduction);
                }
            });
        });

        fields = [...fields, ...quizInFields];

        await setFields([...fields]);

        if (!haveRegistration) {
            setBeneficiaryRegister({
                fields,
                quiz: []
            });
        }
        else {
            setBeneficiaryRegister({
                fields,
                quiz: [...beneficiaryRegister.quiz]
            });
        }

        if (data['optionSendAcceptanceTerm']) {
            setOptionSendAcceptanceTerm(Number(data['optionSendAcceptanceTerm']));
        }

        setIsActiveLoader(false);

        return fields;
    }


    function addQuiz(data: IFormInput, quiz: InductionQuizConfiguration) {

        setIsActiveLoader(true);
        /*Condição adicionada para casos que existe o nome do prescritor como questão*/

        const questionPrescriberNameId = quiz.questions.filter(
            question => ['question_prescriber_name', 'question_prescriber_name_not_validation']
                .includes(question.questionAlias.toLowerCase()))[0]?.id;

        const receiveAccessId = quiz.questions.filter(
            question => question.questionAlias.toLowerCase() === 'question_receive_access')[0]?.id;

        const responsibleAcceptanceId = quiz.questions.filter(
            question => question.questionAlias.toLowerCase() === 'question_responsible_acceptance')[0]?.id;

        const responsibleBirthDateId = quiz.questions.filter(
            question => question.questionAlias.toLowerCase() === 'question_responsible_birth_date')[0]?.id;

        const responsibleDegreeKinshipId = quiz.questions.filter(
            question => question.questionAlias.toLowerCase() === 'question_responsible_degree_of_kinship')[0]?.id;

        if (questionPrescriberNameId) {
            data[String(questionPrescriberNameId)] = prescriber.name || data[String(questionPrescriberNameId)];
        }

        if (receiveAccessId) {
            data[String(receiveAccessId)] = questionReceiveAccess;
        }

        if (responsibleAcceptanceId) {
            data[String(responsibleAcceptanceId)] = "true";
        }

        if (responsibleBirthDateId) {
            data[String(responsibleBirthDateId)] = questionResponsibleBirthDate || data[String(responsibleBirthDateId)];
        }

        if (responsibleDegreeKinshipId) {
            data[String(responsibleDegreeKinshipId)] = questionResponsibleDegreeKinship || data[String(responsibleDegreeKinshipId)];
        }

        const questionAcceptContactTypes = quiz.questions.filter(
            question => question.questionAlias.toLowerCase() === 'question_accept_contact_types');

        if (questionAcceptContactTypes.length > 0) {
            questionAcceptContactTypes.map(item => {
                let field = beneficiaryRegister?.fields?.find(x => x.columnName == item.title);
                if (field) {
                    data[item.id] = field.value || "false";
                }
            });
        }


        let quizCaregiver: any = [];

        if (fieldsCaregiver.length > 0 && beneficiaryHasCaregiver) {
            const CaregiverQuizzes = quiz.questions.filter(x => caregiverApiAlias.includes(x.questionAlias.toLocaleLowerCase())).map(x => { return { id: x.id, questionAlias: x.questionAlias.toLocaleLowerCase() } })


            quizCaregiver = CaregiverQuizzes.map(x => {
                return {
                    id: x.id,
                    value: caregiverData[x.questionAlias]
                }

            })
        }

        const questions = quiz.questions?.map(question => {
            if (data.hasOwnProperty(String(question.id))) {
                if (((question.questionAlias.toLowerCase() === 'question_accepted_term'
                    || question.questionAlias.toLowerCase() === 'question_late-term_acceptance'))) {

                    data[question.id] = data[question.id] || `${termAccepted}`
                }
                return {
                    id: question.id,
                    value: data[question.id]
                } as QuestionsResponse
            }
            return {} as QuestionsResponse;

        }).filter(f => f?.id)
            .concat(quizCaregiver as unknown as QuestionsResponse);

        const obj: QuizInduction = {
            id: quiz.id,
            configurationId: quiz.configurationId,
            skuId: quiz.drugs?.map(sku => sku.skuId),
            questions: questions
        };

        const newQuizzes = quizzes.filter(f => f.id !== quiz.id);
        setQuizzes([...newQuizzes, obj]);
        // setQuizzes([obj]);
        setPrescriber({} as Prescriber);
        setAddedQuiz(true);
        setIsActiveLoader(false);
    }

    async function getStore(storeCnpj: string) {
        setIsActiveLoader(true);
        sessionStorage.removeItem('');
        const normalizedStoreCnpj = normalizeCnpj(storeCnpj);
        const result = await api.get<ResponseStore>(`Chain/api/v1/Store/CNPJ/Active/${encodeURIComponent(normalizedStoreCnpj)}`
            , {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        ).then(response => {
            if (response.status !== 200) {
                toast.error('Erro na consulta de loja!');
                return {} as Store;
            }

            if (!response.data.success && response.data?.error?.code === 404) {
                toast.error('Não foi possível localizar a loja informada.');

                return {} as Store;
            }

            setStore(response.data.data);

            setDisplayStore(false);
            setDisplayBenefits(true);

            const storeId = response.data.data.id;
            sessionStorage.setItem('storeId', storeId.toString());

            return response.data.data;
        }).catch((error) => {
            console.log(error);
            toast.error('Ocorreu um erro na aplicação por favor tente mais tarde!');
            return {} as Store;
        }).finally(() => {
            setIsActiveLoader(false);
        });

        return result;
    }

    async function getBenefits() {
        setIsActiveLoader(true);
        const normalizedStoreCnpj = normalizeCnpj(store.cnpj);
        const result = await api.get<ResponseBenefits>(`Client/api/v1/Client/Industry/Associated/notValidatePreValidationStore/${encodeURIComponent(normalizedStoreCnpj)}`
            , {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
        ).then(response => {
            if (response.status !== 200) {
                toast.error('Erro na consulta dos Programas de Indústria!');
                return [] as Benefit[];
            }

            if (!response.data.success && response.data?.error?.code === 404) {
                toast.error('Não foi possível localizar nenhum Programa de Indústria.');

                return [] as Benefit[];
            }

            setDisplayStore(false);
            setDisplayBenefits(true);

            return response.data.data;
        }).catch((error) => {
            toast.error('Ocorreu um erro na aplicação por favor tente mais tarde!');
            return [] as Benefit[];
        }).finally(() => {
            setIsActiveLoader(false);
        });

        const data = originOfAccessPosWeb ? result : result.filter(c => c.benefit.id !== 91021);

        setBenefits(data);

        return data;
    }

    const setValueDisplaySearch = (value: boolean) => setDisplaySearch(value);
    const setValueDisplayForm = (value: boolean) => setDisplayForm(value);
    const setValueDisplayQuizzes = (value: boolean) => setDisplayQuizzes(value);

    function getAcceptanceQuizId() {
        return configuration.quiz?.find(
            quiz => quiz.questions?.some(
                question => question.questionAlias.toLowerCase() === 'question_accepted_term'
                    || question.questionAlias.toLowerCase() === 'question_late-term_acceptance'
            )
        )?.id || 0;
    }

    function normalizeDeliveryChannel(tipoEnvio?: string) {
        if (acceptanceTermEmailOnlyBenefitIds.includes(benefitId)) {
            return 'email';
        }

        return tipoEnvio === 'sms' ? 'sms' : 'email';
    }

    function getDeliveryChannelCode(tipoEnvio?: string) {
        return normalizeDeliveryChannel(tipoEnvio) === 'sms' ? 1 : 2;
    }

    async function getBeneficiaryPreCad(): Promise<BeneficiaryPreCadastro | null> {
        setIsActiveLoader(true);

        const cpf = beneficiaryInfo?.cpf || cardHolderNumber;
        const quizId = beneficiaryInfo?.quizId || getAcceptanceQuizId();
        const result = await getBeneficiaryPreCadastro(token || "", cpf || "", quizId);

        if (result.status === 404 || result.errorCode === 404) {
            setTermDeclined(true);
            setIsActiveLoader(false);
            return null;
        }

        if (result.status === 401 || result.errorCode === 401) {
            setIsActiveLoader(false);
            toast.error(result.message || 'Não foi possível validar o termo de aceite. Faça uma nova tentativa.');
            return null;
        }

        if (!result.data) {
            setIsActiveLoader(false);

            if (result.message) {
                toast.error(result.message);
            }

            return null;
        }

        setTermAccepted(result.data.isAceite);
        setIsActiveLoader(false);

        return result.data;
    }

    async function reSendTerm(tipoEnvio: string) {
        const deliveryChannel = normalizeDeliveryChannel(tipoEnvio);

        if (deliveryChannel === 'email' && beneficiaryInfo) {
            // envia por email o termo
            await sendEmail(beneficiaryInfo.email, beneficiaryInfo.email, benefitName, benefitId, beneficiaryInfo.quizId, beneficiaryInfo.cpf);
        } else if (deliveryChannel === 'sms' && beneficiaryInfo) {
            // envia via sms
            await sendSms(beneficiaryInfo.celular, beneficiaryInfo.quizId, beneficiaryInfo.email, beneficiaryInfo.cpf);
        }
    }

    function backToContact() {
        setEditContact(true);
        setDisplaySearch(true);
        setDisplayValidTermAccepted(false);
    }

    async function handleEditContact(data: ISearchFormInput) {
        const quizId = getAcceptanceQuizId();

        const beneficiaryPreCad = await getBeneficiaryPreCad();

        if (beneficiaryPreCad === null) {
            return;
        }

        beneficiaryPreCad.cpf = data.cpf.replaceAll(/\D/g, "");
        beneficiaryPreCad.telefone = data.celular.replaceAll(/\D/g, "");
        beneficiaryPreCad.email = data.email;
        beneficiaryPreCad.tipoEnvio = getDeliveryChannelCode(data.tipoEnvio);
        beneficiaryPreCad.codigoQuiz = quizId;

        data.cpf = data.cpf.replaceAll(/\D/g, "");
        data.celular = data.celular.replaceAll(/\D/g, "");
        data.tipoEnvio = normalizeDeliveryChannel(data.tipoEnvio);
        data.quizId = quizId;

        await api.put("/Beneficiary/api/v1/BeneficiaryPreCadastro", beneficiaryPreCad, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        if (data.tipoEnvio === 'email') {
            // envia por email o termo
            await sendEmail(data.email, data.email, benefitName, benefitId, quizId, data.cpf);
        } else if (data.tipoEnvio === 'sms') {
            // envia via sms
            await sendSms(data.celular, quizId, data.email, data.cpf);
        }

        setBeneficiaryInfo(data);
        setEditContact(false);
        setDisplaySearch(false);
        setDisplayValidTermAccepted(true);
    }

    function closeModalErroAddBeneficiaryPreCad() {
        setErrorAddBeneficiaryPreCad(false);
    }

    return (
        <InductionContext.Provider
            value={{
                benefitId
                , configuration
                , beneficiaryRegister
                , beneficiaryBirthDate
                , fields
                , haveRegistration
                , displayBenefits
                , displayStore
                , displaySearch
                , displayForm
                , displayQuizzes
                , displayValidTermAccepted
                , termDeclined
                , errorAddBeneficiaryPreCad
                , errorAddBeneficiaryPreCadMessage
                , setValueDisplaySearch
                , setValueDisplayForm
                , setValueDisplayQuizzes
                , cardHolderNumber
                , address
                , prescriber
                , store
                , benefits
                , beneficiaryInfo
                , canProceedWithoutAccept
                , editContact
                // , getBeneficiary
                , setBeneficiary
                , getPrescriber
                , getAddressZipCode
                , getStore
                , getBenefits
                , addQuiz
                , addFields
                , resetQuizzes
                , resetAll
                , addedQuiz
                , quizzes
                , benefitName
                , showLGPDModal
                , questionResponsibleName
                , questionResponsibleBirthDate
                , questionResponsibleDegreeKinship
                , questionResponsibleAcceptance
                , setQuestionResponsibleAcceptance
                , questionResponsibleDocument
                , questionReceiveAccess
                , isActiveLoader
                // , sendAcceptanceTerm
                , resetPrescriber
                , optionSendAcceptanceTerm
                , setOptionSendAcceptanceTerm
                , contact0
                , contact1
                , contact2
                , contact3
                , setContact0
                , setContact1
                , setContact2
                , setContact3
                , setShowLGPDModal
                , beneficiaryIdentifier
                , showHeaderFooter
                , resetBeneficiary
                , saveInformationNewTableToSendTerm
                , ProceedToForm
                , getBeneficiaryPreCad
                , GoToForm
                , reSendTerm
                , backToContact
                , handleEditContact
                , closeModalDeclinedTerm
                , isUpdate
                , setIsUpdate
                , fieldsCaregiver
                , setFieldsCaregiver
                , caregiverData
                , setCaregiverData
                , beneficiaryHasCaregiver
                , setBeneficiaryHasCaregiver
                , plainHasCaregiver
                , setPlainHasCaregiver
                , checkBoxesCaregiven
                , setCheckBoxesCaregiven
                , lastCaregivenData
                , setLastCaregivenData
                , fieldsCaregiverData
                , setFieldsCaregiverData
                , closeModalErroAddBeneficiaryPreCad
                ,token
                ,validateRepresentativeCode
            }}>
            <>
                {children}
                <AlertModal
                    isOpen={showModalResultInserted}
                    onRequestClose={() => setShowModalResultInserted(false)}
                    sucess={!beneficiaryInsertedError}
                    termAccepted={termAccepted}
                    isUpdate={isUpdate}
                />
                <ModalValidTerm
                    show={termDeclined}
                    content={`O paciente declinou de participar do programa, caso o mesmo ainda tenha interesse favor reiniciar o cadastro.`}
                    onClose={closeModalDeclinedTerm}
                    onCloseX={closeModalDeclinedTerm}
                />
            </>
        </InductionContext.Provider>
    )
}

export function useInduction(): InductionContextData {
    const context = useContext(InductionContext);

    return context;
}
